import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

const ContactApp = () => {
	const [state, handleSubmit] = useForm('manbqwnb');

	return (
		<div className="font-os h-full overflow-y-auto bg-os-surface text-os-text">
			<div className="mx-auto max-w-lg px-8 py-8">
				<div className="rounded-xl border border-white/10 bg-os-surface2/60 px-5 py-4">
					<div className="flex items-center gap-3 text-sm">
						<span className="w-14 shrink-0 text-os-textdim">To:</span>
						<span className="rounded-md bg-os-surface3/80 px-2.5 py-1 text-os-text">
							oluwatobitogun@gmail.com
						</span>
					</div>
					<div className="my-3 h-px bg-white/10" />
					<div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-os-textdim">
						<a
							href="https://www.linkedin.com/in/oluwatobi-togun/"
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-1.5 transition-colors hover:text-os-text"
						>
							<i className="fa-brands fa-linkedin-in" />
							LinkedIn
						</a>
						<a
							href="https://github.com/TOGUNOLUWATOBI"
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center gap-1.5 transition-colors hover:text-os-text"
						>
							<i className="fa-brands fa-github" />
							GitHub
						</a>
						<span className="flex items-center gap-1.5">
							<i className="fa-solid fa-location-dot" />
							Stavanger, Norway
						</span>
					</div>
				</div>

				{state.succeeded ? (
					<div className="mt-10 flex flex-col items-center rounded-xl border border-white/10 bg-os-surface2/40 px-6 py-12 text-center">
						<div className="flex h-14 w-14 items-center justify-center rounded-full bg-os-green/15">
							<i className="fa-solid fa-check text-2xl text-os-green" />
						</div>
						<h2 className="mt-4 text-lg font-semibold text-os-text">Message sent</h2>
						<p className="mt-1.5 max-w-xs text-sm text-os-textdim">
							Thanks for reaching out — I'll get back to you as soon as I can.
						</p>
						<button
							onClick={() => window.location.reload()}
							className="mt-6 inline-flex items-center gap-2 rounded-lg border border-white/10 bg-os-surface3 px-4 py-1.5 text-sm font-medium text-os-text transition-colors hover:bg-os-surface3/80"
						>
							<i className="fa-solid fa-arrow-rotate-left" />
							Send another message
						</button>
					</div>
				) : (
					<form onSubmit={handleSubmit} className="mt-6 space-y-4">
						<div>
							<label htmlFor="name" className="mb-1.5 block text-xs font-medium text-os-textdim">
								Name
							</label>
							<input
								id="name"
								type="text"
								name="name"
								required
								className="w-full rounded-lg border border-white/10 bg-os-surface2 px-3 py-2 text-sm text-os-text placeholder:text-os-textdim/60 outline-none transition-shadow focus:ring-2 focus:ring-os-accent"
								placeholder="Your name"
							/>
							<ValidationError prefix="Name" field="name" errors={state.errors} className="mt-1 text-xs text-os-red" />
						</div>

						<div>
							<label htmlFor="email" className="mb-1.5 block text-xs font-medium text-os-textdim">
								Email
							</label>
							<input
								id="email"
								type="email"
								name="email"
								required
								className="w-full rounded-lg border border-white/10 bg-os-surface2 px-3 py-2 text-sm text-os-text placeholder:text-os-textdim/60 outline-none transition-shadow focus:ring-2 focus:ring-os-accent"
								placeholder="you@example.com"
							/>
							<ValidationError prefix="Email" field="email" errors={state.errors} className="mt-1 text-xs text-os-red" />
						</div>

						<div>
							<label htmlFor="subject" className="mb-1.5 block text-xs font-medium text-os-textdim">
								Subject <span className="text-os-textdim/60">(optional)</span>
							</label>
							<input
								id="subject"
								type="text"
								name="subject"
								className="w-full rounded-lg border border-white/10 bg-os-surface2 px-3 py-2 text-sm text-os-text placeholder:text-os-textdim/60 outline-none transition-shadow focus:ring-2 focus:ring-os-accent"
								placeholder="What's this about?"
							/>
						</div>

						<div>
							<label htmlFor="message" className="mb-1.5 block text-xs font-medium text-os-textdim">
								Message
							</label>
							<textarea
								id="message"
								name="message"
								required
								rows={6}
								className="w-full resize-none rounded-lg border border-white/10 bg-os-surface2 px-3 py-2 text-sm text-os-text placeholder:text-os-textdim/60 outline-none transition-shadow focus:ring-2 focus:ring-os-accent"
								placeholder="Write your message…"
							/>
							<ValidationError prefix="Message" field="message" errors={state.errors} className="mt-1 text-xs text-os-red" />
						</div>

						<div className="flex justify-end pt-2">
							<button
								type="submit"
								disabled={state.submitting}
								className="inline-flex items-center gap-2 rounded-lg bg-os-accent px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-os-accent/90 active:bg-os-accent/80 disabled:cursor-not-allowed disabled:opacity-60"
							>
								{state.submitting ? (
									<>
										<i className="fa-solid fa-circle-notch animate-spin" />
										Sending…
									</>
								) : (
									<>
										<i className="fa-solid fa-paper-plane" />
										Send
									</>
								)}
							</button>
						</div>
					</form>
				)}
			</div>
		</div>
	);
};

export default ContactApp;
